<div class="container">

      <form class="form-signin" #ngForm="ngForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <img src="assets/img/logo.png" style="margin:0;width:100%" class=""  border="0">
        <h2 class="form-signin-heading">sign in now</h2>
        <div class="login-wrap">
            <div class="service-error" *ngIf="loginError" style="color:red;font-size:14px;margin-top:10px;text-align:center;">
              <span>{{loginError}}</span>
            </div>
            <input type="text" class="form-control" placeholder="Username / Email" autofocus formControlName="username">
            <input type="password" class="form-control" placeholder="Password" formControlName="password">
            <label class="checkbox">
                <input type="checkbox" value="remember-me" formControlName="remember_me"> Remember me
                <span class="pull-right">
                    <a data-toggle="modal" href="#myModal"> Forgot Password?</a>
                </span>
            </label>
            <button class="btn btn-lg btn-login btn-block" type="submit" [disabled]="!loginForm.valid">Sign in</button>
        </div>
        </form>

        <!-- Modal -->
        <div aria-hidden="true" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="myModal" class="modal fade">
            <div class="modal-dialog">
                <div class="modal-content">
                  <form #ngForm="ngForm" [formGroup]="forgotPassword" (ngSubmit)="resetPasswordEmail()">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        <h4 class="modal-title">Forgot Password ?</h4>
                    </div>
                    <div class="modal-body">
                        <p>Enter your e-mail address below to reset your password.</p>
                        <div class="alert alert-danger fade in" *ngIf="formSubmitted && !formResult">
                          <button data-dismiss="alert" class="close close-sm" type="button">
                            <i class="fa fa-times"></i>
                          </button>
                          {{formResultMessage}}
                        </div>

                        <div class="alert alert-success fade in" *ngIf="formSubmitted && formResult">
                          <button data-dismiss="alert" class="close close-sm" type="button">
                            <i class="fa fa-times"></i>
                          </button>
                          {{formResultMessage}}
                        </div>
                        <input formControlName="email" type="text" name="email" placeholder="Email" autocomplete="off" class="form-control placeholder-no-fix">

                    </div>
                    <div class="modal-footer">
                        <button data-dismiss="modal" class="btn btn-default" type="button">Cancel</button>
                        <button class="btn btn-success" type="submit">Submit</button>
                    </div>
                  </form>  
                </div>
            </div>
        </div>
        <!-- modal -->

</div>